export default {
  'favorite-page': () => import('@/components/FavoritePage.vue'),
  'carousel': () => import('@/components/carousel.vue'),
  'carousel-items': () => import('@/components/carousel-items.vue'),
  'catalog-listing': () => import('@/components/catalog-listing.vue'),
  'catalog-menu': () => import('@/components/catalog-menu.vue'),
  'element-product': () => import('@/components/page-product.vue'),
  'element-product-mobile': () => import('@/components/page-product-mobile.vue'),
  'favorite-sidebar': () => import('@/components/favorite-sidebar.vue'),
  'infinite-feed': () => import('@/components/infinite-feed.vue'),
  'infinite-similar': () => import('@/components/infinite-similar.vue'),
  'listing-card': () => import('@/components/listing-card.vue'),
  'listing-search': () => import('@/components/listing-search.vue'),
  'search-results': () => import('@/components/search-results.vue'),
  'static-listing': () => import('@/components/static-listing.vue'),
  'location': () => import('@/components/location/template.vue'),
  'pagination': () => import('@/components/pagination.vue'),
  'popup-product': () => import('@/components/popup-product.vue'),
  'smart-filter': () => import('@/components/smart-filter.vue'),
  'star-icon': () => import('vue-material-design-icons/Star.vue'),
  'user-field': () => import('@/components/user-field/template.vue'),
  'v-form': () => import('@/components/v-form.vue'),
  'vuebox': () => import('@/components/vuebox.vue'),
  'order-form': () => import('@/components/order/index.vue'),
};
